import React, { useRef } from "react";
import ReactDOM from "react-dom";
import EmailIcon from "@mui/icons-material/Email";
import "./styles.css"

interface MobileShareSheetProps {
  open: boolean;
  onClose: () => void;
  doc: any

}

const MobileShareSheet: React.FC<MobileShareSheetProps> = ({
  open,
  onClose,
  doc,
}) => {
  const mailRef = useRef(null);

  const handleClick = () => {
    const anchor = mailRef.current as HTMLAnchorElement | null;
    if (anchor) {
      anchor.click();
    }
    onClose();
  };

  const subject = "Shared Search Results from ABSYZ Pre-Sales Portal";
  const body = `Hi there,

Please find attached the document containing the search results you requested via the ABSYZ Pre-Sales Portal.

Download Link: ${doc.download_link}

Regards,
Pre-sales Team`;
  const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  if (!open || !doc) return null;

  const sheet = (
    <div className="mobile-share-sheet" onClick={onClose}>
      <div className="mobile-share-sheet-content" onClick={(e) => e.stopPropagation()}>
        <div className="mobile-share-option">
          <a
            href={mailtoLink}
            target="_top"
            style={{ display: "none" }}
            ref={mailRef}
          >
            Hidden Mail Link
          </a>

          <div
            onClick={handleClick}
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <EmailIcon sx={{ marginRight: 1 }} />
            Share via Email
          </div>
        </div>
        <div className="mobile-share-option cancel" onClick={onClose}>
          Cancel
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(sheet, document.body);
};

export default MobileShareSheet;
